export default (value) => {
  if (!value) {
    return '';
  }
  const [firstLetter, ...otherLetters] = value.toString();
  return firstLetter.toUpperCase() + otherLetters.join('').toLowerCase();
};
